export default __webpack_public_path__ + "static/media/location-pin.bb459d62.png";